import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SessionExpiredDialogService } from '../session-expired-dialog/session-expired-dialog.service';
import { ApiErrorAlertService } from './api-error-alert.service';

/**
 * Surfaces failed API calls to the admin user, then rethrows the error so page-level handlers keep
 * working. A rejected token (401 or 403) asks the admin to sign in again — a fresh sign-in issues a
 * token with up-to-date roles; any other failure shows the generic alert.
 */
export const apiErrorAlertInterceptor: HttpInterceptorFn = (req, next) => {
  const apiErrorAlert = inject(ApiErrorAlertService);
  const sessionExpiredDialog = inject(SessionExpiredDialogService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        if (isSessionExpired(error)) {
          sessionExpiredDialog.open();
        } else {
          apiErrorAlert.showError();
        }
      }
      return throwError(() => error);
    }),
  );
};

function isSessionExpired(error: HttpErrorResponse): boolean {
  return error.status === HttpStatusCode.Unauthorized || error.status === HttpStatusCode.Forbidden;
}
